"use strict";

exports.__esModule = true;
exports.useCreateForm = useCreateForm;

var _react = require("react");

var _hooks = require("@bydesign-ui/hooks");

var _form = require("../../../models/form");

function useCreateForm(props) {
  var form = props.form,
      onModelChange = props.onModelChange,
      onSubmit = props.onSubmit,
      onSubmitFailed = props.onSubmitFailed,
      onValuesChange = props.onValuesChange,
      defaultModel = props.defaultModel;
  var ins = (0, _hooks.useSingleton)(function () {
    if (form != null) {
      return form;
    }

    return new _form.Form({
      model: defaultModel
    });
  });
  (0, _react.useEffect)(function () {
    ins.addListener('model-change', onModelChange);
    ins.addListener('values-change', onValuesChange);
    ins.addListener('submit', onSubmit);
    ins.addListener('submit-failed', onSubmitFailed);
    return function () {
      ins.removeListener('model-change', onModelChange);
      ins.removeListener('values-change', onValuesChange);
      ins.removeListener('submit', onSubmit);
      ins.removeListener('submit-failed', onSubmitFailed);
    };
  }, []);
  return ins;
}